<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">3. Direção e Liderança</div>
    <div v-if="!loading">
      <unicom-linha
        class="espacamento-vertical"
        v-for="(info, index) in Object.entries(objetoInformacoes)"
        :key="index"
      >
        <unicom-coluna sm="12" md="6">
          <div class="medio segunda-cor-fonte">{{ nomeCampos[info[0]] }}:</div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div class="medio">
            {{ info[1] }}
          </div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "DirecaoLideranca",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      objetoInformacoes: {
        nomeDiretorTecnico: "SERGIO ANTONIO PINOTTI",
        conselho: "Conselho Regional de Fisioterapia e Terapia Ocupacional",
        registroConselho: "457650000000000",
        ufConselho: "SP"
      },
      nomeCampos: {
        nomeDiretorTecnico: "Nome do diretor técnico",
        conselho: "Conselho",
        registroConselho: "Registro do conselho",
        ufConselho: "UF do conselho"
      }
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getDirecaoELideranca(this.idRnpPrestador)
          .then(res => {
            let objetoIndicadoresEstado = res.data;

            Object.entries(objetoIndicadoresEstado).forEach(e => {
              this.objetoInformacoes[e[0]] = e[1] ? e[1] : " - ";
            });

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-vertical {
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
